import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GiantConfigService } from '../admin-layout/services/config-service';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { LoginRepository } from 'src/app/repositories/login/LoginRepository';
import { Login } from 'src/app/models/login.model';
import { MatRadioButton } from "@angular/material/radio";
import { giantAnimations } from '../admin-layout/animations';
import { Usertf } from 'src/app/models/Usertf.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';
import { navigation } from 'src/app/shared/navigation';
import { GiantNavigationService } from '../admin-layout/navigation/navigation.service';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'tf-authentication',
    templateUrl: './tf-verificationcode-layout.component.html',
    styleUrls: ['./tf-authentication-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: giantAnimations
})
export class TfcodeLayoutComponent implements OnInit {

    userRoles: any[] = [];
    data: any = {};
    userModel = new Usertf();
    PhoneNumber: string;
    Email: string
    type:string='';
    constructor(
        private _giantConfigService: GiantConfigService,
        private _formBuilder: UntypedFormBuilder,
        private _loginRepository: LoginRepository,
        private _router: Router,
        private _userRepository: UserRepository,
        private _giantSnackBarService: GiantSnackBarService,
        private _giantNavigationService: GiantNavigationService,
        private http : HttpClient,
       public route: ActivatedRoute
        //private snackBar: MatSnackBar
    ) {
        // Configure the layout
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
        this.type=decodeURIComponent(this.route.snapshot.queryParams['type']);
      
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        this._userRepository.GetUsersById().subscribe((res: any) => {
            var mobile = "****";
            var email = "*********"
            res.UserDetail.map(user => {

                this.userModel = user;
                this.PhoneNumber = this.userModel.PhoneNo;
                this.Email = this.userModel.Email;
                if (this.userModel.PhoneNo.length > 3) {
                    var Mobilephone = this.userModel.PhoneNo.substring(this.userModel.PhoneNo.length - 3);
                    this.userModel.PhoneNo = mobile + Mobilephone
                }
                var EmailAddress = this.userModel.Email.substring(this.userModel.Email.indexOf('@'));
                this.userModel.Email = email + EmailAddress

            });
        });
        if (navigation[0].children.length > 0) {
            navigation[0].children = []
        }
    }


    UpdateClientAuthenticationCode() {

debugger
        if (this.userModel.Type == "" || this.userModel.Type == "undefined") {
            //this.openSnackBar("Please choose the document then click attach", "Ok");
            return;
        }

        if (this.userModel.Type == "Email") {
            this.userModel.AuthType = '1'
            this.userModel.AuthChannelValue = this.Email
        }
        else {
            this.userModel.AuthType = '2'
            this.userModel.AuthChannelValue = this.PhoneNumber
        }
        this._userRepository.UpdateClientAuthenticationCode(this.userModel).subscribe((res: any) => {
            if (res.UserDetail[0].ErrorCode == 0) {

                this._giantSnackBarService.snackbarSuccess(res.UserDetail[0].ErrorMessage);

                this._userRepository.GetAccessRights().subscribe((res: any) => {
                    debugger
                    if (res._obj.UserAccessRights.length > 0) {
                        for (let i = 0; i < res._obj.UserAccessRights.length; i++) {

                            var child = {
                                id: res._obj.UserAccessRights[i].PageName, title: res._obj.UserAccessRights[i].PageTitle,
                                type: res._obj.UserAccessRights[i].DisplayType,
                                icon: res._obj.UserAccessRights[i].StateIcon, url: res._obj.UserAccessRights[i].StateName
                            };
                            navigation[0].children.push(child);
                        }
                        localStorage.setItem('DisplayName', res._obj.UserAccessRights[0].UserDisplayName);
                    }
                    
                    this._giantNavigationService.unregister('main');

                    this._giantNavigationService.register('main', navigation);

                    // Set the main navigation as our current navigation
                    this._giantNavigationService.setCurrentNavigation('main');
                    this._router.navigate(['/dashboard']).then(() => {
                        window.location.reload();
                      });
                });

            }
            else 
            {
                this._giantSnackBarService.snackbarError(res.UserDetail[0].ErrorMessage);
                return;
            }
        });

    }

    // updateContact(contact): Promise<any>
    // {
    //     return new Promise((resolve, reject) => {

    //         this.http.post('api/contacts-contacts/' + contact.id, {...contact}).subscribe(response => {
                  
    //                 resolve(response);
    //             });
    //     });
    // }
    SendAuthenticationCode() {

       
      

        if (this.type == "Email") {
            this.userModel.AuthType = '1'
            this.userModel.AuthChannelValue = this.Email
        }
        if(this.type == "SMS") {
            this.userModel.AuthType = '2'
            this.userModel.AuthChannelValue = this.PhoneNumber
        }
        this._userRepository.SendAuthenticationCode(this.userModel).subscribe((res: any) => {
            if (res.UserDetail[0].ErrorCode == 0) {
                this._giantSnackBarService.snackbarSuccess(res.UserDetail[0].ErrorMessage);
                return;
                // this._router.navigate(['/pages/dashboard'])
            }
        });

    }

    // openSnackBar(message: string, action: string) {
    //     this.snackBar.open(message, action, {
    //         duration: 3000,

    //         verticalPosition: "top"
    //     });
    //   }
}
